export const enum OrderActionType {
  REDIRECT_ORDER = 'REDIRECT_ORDER',
  STORES = 'STORES',
  MENU = 'MENU',
  RULE = 'RULE',
  REDEEM = 'REDEEM',
  WEBCDSVOS = 'WEBCDSVOS',
  UPDATE_STORE = 'UPDATE_STORE',
}
